import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, PopoverController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { PinpopoverPage } from '../pinpopover/pinpopover';
import { ChooseindoorpausePage } from '../chooseindoorpause/chooseindoorpause';

import { LoginPage } from '../login/login';

/**
 * Generated class for the BeaconprocesshomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-beaconprocesshome',
  templateUrl: 'beaconprocesshome.html',
})
export class BeaconprocesshomePage {
  loadingData: boolean = false
  isTabletDeks: boolean = false
  // workoders = []
  notopen = []
  open = []
  _hasOpenedWithoutPauseOrder = false;
  _hasOpenedOrder = false;
  _multipleorders = '0';

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController, public popoverCtrl: PopoverController, public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    var _that = this
    this.gn._Post('/api/gn/getProcessMultiple', { userid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that._multipleorders = _data + ''
    })

    console.log('ionViewDidLoad WorkorderspinPage');
    this.loadData()
    this.checkIsTablet()
  }
  checkIsTablet() {
    // if (window.innerHeight > window.innerWidth) {
    //   this.tfm.isPhone = true
    //   console.log('isPhone')
    // } else {
    //   this.tfm.isPhone = false
    //   console.log('isDesktop')
    // }

    if (window.innerWidth > 768) {
      this.isTabletDeks = true
      console.log('isPhone')
    } else {
      this.isTabletDeks = false
      console.log('isDesktop')
    }
    // if (this.tfm.isPhone == true) {
    //   this.router.navigateByUrl('home', { skipLocationChange: true })
    // } else {
    //   this.router.navigateByUrl('tasks', { skipLocationChange: true })
    // }

  }

  sec2str2(_sec) {
    if (_sec == undefined || _sec == null) _sec = -1;
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      return str;
    }
    else {
      return '-1';
    }
  }

  loadData() {
    this._hasOpenedOrder = false;
    this._hasOpenedWithoutPauseOrder = false;
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getPinLiveWorkOrders', { pinid: this.gn.crypt(this.gn.pin.pinid), type: this.gn.crypt('beacon'), userid: this.gn.crypt(this.gn.user.UserId), offset: this.gn.crypt(-1) }, function (_data) {
      for (let i = 0; i < _data.length; i++) {
        // _data[i].dt = moment(_data[i].dt).format(this.gn.user.DFormat)
        _data[i].dt = moment(_data[i].dt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt).format(_that.gn.user.TFormat)
        _data[i].incoming = '1'
        _data[i].assignrfid = '1'

        _data[i].avgdurationstr = _that.sec2str2(_data[i].avgduration)

        if (_data[i].isopened == '1' && _data[i].onpause1 == 0) _that._hasOpenedWithoutPauseOrder = true;
        if (_data[i].isopened == '1') _that._hasOpenedOrder = true;
      }
      // _that.workoders = _data
      _that.gn.workoders = _data
      _that.resetSearch()
      _that.loadingData = false
    })

  }

  // takeOrder(_wo) {
  //   if (_wo.incoming + '' == '0' || _wo.assignrfid + '' == '0') {
  //   } else {
  //     var _status = 0
  //     if (_wo.isopened + '' == '0') {
  //       _status = 1
  //     } else {
  //       _status = 0
  //     }
  //     var _that = this
  //     // _that.gn.loadWaiting();
  //     this.gn._Post('/api/gn/updateStatusPinWorkOrder', { driverid: this.gn.crypt(_wo.driverid), pinid: this.gn.crypt(this.gn.pin.pinid), id: this.gn.crypt(_wo.id), status: this.gn.crypt(_status), clientid: this.gn.crypt(this.gn.user.ClientId), userid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
  //       if (_data.msg == 'error') {
  //         let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
  //         toast.present();
  //         return
  //       }
  //       _that.loadData()


  //     })

  //   }
  // }
  prikaz() {
    console.log('prikaz')
  }

  logout() {
    this.gn.clearData()
    this.navCtrl.parent.setRoot(LoginPage)
  }

  takeOrder(_wo) {
    if (this._hasOpenedWithoutPauseOrder && this._multipleorders == '0') {
      let toast = this.toastCtrl.create({ message: this.dic.l["cannottakeorder"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    var _status = 0
    var titletext = ''
    var subtitletext = ''
    if (_wo.incoming + '' == '0' || _wo.assignrfid + '' == '0') {
    } else {
      var _status = 0
      if (_wo.isopened + '' == '0') {
        _status = 1
        titletext = this.dic.l['Takeorder'];
        subtitletext = this.dic.l['areusuretakeorder'];
      } else {
        _status = 0
        titletext = this.dic.l['Closeorder'];
        subtitletext = this.dic.l['areusurecloseorder'];
      }

      var _that = this;
      let alert = _that.alertCtrl.create({
        title: titletext,
        subTitle: subtitletext + ' <b>' + _wo.title + '</b> ?',
        buttons: [
          {
            text: _that.dic.l['ok'],
            handler: data => {
              _that.gn._Post('/api/gn/updateStatusPinWorkOrder', { driverid: _that.gn.crypt(_that.gn.user.driverid), pinid: _that.gn.crypt(-1/*_that.gn.pin.pinid*/), id: _that.gn.crypt(_wo.id), status: _that.gn.crypt(_status), clientid: _that.gn.crypt(_that.gn.user.ClientId), userid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
                console.log(_data, 'daj da vidam data')
                if (_data.msg == 'error') {
                  let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
                  toast.present();
                  return
                }
                _that.loadData()
              })
              //userite od mebel vi indoor da gi odlogira avtomatski posle 20sek od najavata
              if (_that.gn.user.ClientId + '' == '769' && _that.gn.user.driverid + '' != '-1') {
                //logout samo za neaktivnost da ostane, drugovo se zakomentiruva 11-01-2022
                // setTimeout(() => {
                //   _that.logout();
                // }, 10 * 1000);
              }
            }
          },
          {
            text: _that.dic.l['cancel'],
            role: 'cancel'
          }
        ]
      });
      alert.present();
    }
  }

  presentPopover(myEvent, _wo) {
    var _that = this
    // where opcii
    // 1 se misli od workorderspin
    // 2 se misli od beaconprocesshome
    _wo.ptype = 'rfid'
    _wo.currentdriverid = _that.gn.user.driverid
    _wo.currentpinid = null
    let popover = this.popoverCtrl.create(PinpopoverPage, {
      wo: _wo, where: 1, multipleorders: _that._multipleorders, cb: function (_pause) {
        if (_pause == 1 && _wo.onpause1 == 0) {
          let modal = _that.modalCtrl.create(ChooseindoorpausePage, {
            //obj: _data, seldriver: _seldriver, vid: _vid, 
            cb: function (_pausetypeid) {
              _that.gn._Post('/api/gn/updatePauseType', { ptype: _that.gn.crypt('rfid'), driverid: _that.gn.crypt(_that.gn.user.driverid), id: _that.gn.crypt(_wo.id), pausetypeid: _that.gn.crypt(_pausetypeid) }, function (_data) {
                _that.loadData()
              })
            }
          });
          modal.present();
        } else {
          _that.loadData()
        }
      }
    })
    popover.present({
      ev: myEvent
    });
  }

  resetSearch() {
    for (var i = 0; i < this.gn.workoders.length; i++) {
      this.gn.workoders[i].Visible = true
    }
  }
  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchOrdersPin(val);

  }

  searchOrdersPin(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.gn.workoders.length; i++) {
        if (this.gn._latcyr(this.gn.workoders[i].title.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.gn.workoders[i].title.toLowerCase()).indexOf(val) > -1) {
          this.gn.workoders[i].Visible = true
        } else {
          if (this.gn._latcyr(this.gn.workoders[i].articlename.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.gn.workoders[i].articlename.toLowerCase()).indexOf(val) > -1) {
            this.gn.workoders[i].Visible = true
          }
          else {
            this.gn.workoders[i].Visible = false

          }
        }
      }
    }
    else {
      this.resetSearch()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/beaconprocesshome/beaconprocesshome.ts